import router from "@/core/common/router";
import { queryPost } from "@/core/service/api";
// import { checkLoginIn } from "../service/api";

const standardtable = {
  namespaced: true,
  name: "expressHistory",
  state: {
    expressNum: 0,
  },
  mutations: {
    changeState(state, { payload }) {
      Object.assign(state, payload);
    }
  },
  actions: {
    async history({ commit }, { payload }) {
      const response = await queryPost(payload, "/isg-projectapplication/express/sto/query");
      return response;
    },
    saveExpressNum(context, num) {
      context.commit('changeState', num);
    }
  }
};

export default standardtable;
